import React, { useEffect, useState } from 'react';
import { Particles } from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';
import { loadExternalRepulseInteraction } from 'tsparticles-interaction-external-repulse';

const BirthdayParticles = ({ firstName = 'Friend', lastName = '' }) => {
  const brightColors = ['#FFD700', '#FF6347', '#FF69B4', '#00BFFF', '#DA70D6', '#00FF7F', '#FFA500', '#FF1493'];
  const fontStyles = ['Verdana', 'Arial', 'Georgia', 'Times New Roman', 'Comic Sans MS', 'Courier New', 'Trebuchet MS', 'Impact'];
  
  const [particleColor] = useState(() => brightColors[Math.floor(Math.random() * brightColors.length)]);
  const [particleFont] = useState(() => fontStyles[Math.floor(Math.random() * fontStyles.length)]);
  
  const particlesInit = async (main) => {
    await loadSlim(main);
    await loadExternalRepulseInteraction(main);
  };

  return (
    <div >
      <Particles
        init={particlesInit}
        options={{
          background: {
            color: { value: 'transparent' }
          },
          particles: {
            number: { value: 12 },
            shape: {
              type: 'character',
              options: {
                character: {
                  fill: true,
                  font: particleFont,
                  weight: '900',
                  value: ['Happy', 'Birthday', firstName || 'Friend','🎈']
                }
              }
            },
            size: { value: { min: 20, max: 30 } },
            links: {
              enable: true,
              distance: 550,
              color: '#ffffff',
              opacity: 0.4,
              width: 1,
              frequency: 1,
              blink: false
            },
            move: {
              enable: true,
              speed: 2,
              direction: 'none',
              random: true,
              straight: false,
              outModes: {
                default: 'bounce'
              }
            },
            opacity: { value: 0.9 },
            color: {
              value: particleColor
            },
            rotate: {
              value: { min: 0, max: 360 },
              animation: {
                enable: true,
                speed: 5,
                sync: false
              }
            },
            wobble: {
              distance: 10,
              enable: true,
              speed: {
                angle: 50,
                move: 10
              }
            }
          },
          interactivity: {
            events: {
              onHover: {
                enable: true,
                mode: 'grab',
                parallax: {
                  enable: false
                }
              },
              onClick: {
                enable: true,
                mode: 'push'
              }
            },
            modes: {
              grab: {
                distance: 400,
                links: {
                  opacity: 1
                }
              },
              push: {
                quantity: 1
              }
            }
          }
        }}
      />

    


    </div>
  );
};

export default BirthdayParticles;
